import React from "react";

/**
 * Official "Get it on Google Play" badge (Android).
 * Companion to <AppStoreLink>: matches its height/border/style so the two
 * sit side-by-side cleanly in the hero CTA row and on the dedicated app page.
 *
 * Embedded SVG (no external image) so it survives offline / PWA caching.
 * Visual cues follow the Google Play Brand Guidelines:
 *   https://play.google.com/intl/en_us/badges/
 *  - Original Google Play coloured "play" triangle (red/yellow/green/blue)
 *  - "Disponibile su" (it) + "Google Play" wordmark in Roboto-like sans
 */
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.wnapp.id1778937032200";

export default function PlayStoreLink({
  className = "",
  testid = "playstore-link",
  // Same compact prop as <AppStoreLink>, so the two buttons line up.
  compact = false,
}) {
  const heightClass = compact ? "h-12 md:h-14" : "h-14 md:h-16";
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scarica Vita da Host su Google Play"
      data-testid={testid}
      className={`group inline-flex items-center justify-center rounded-2xl bg-black border border-white/15 hover:border-white/40 px-4 ${heightClass} transition-all hover:bg-white/[0.04] active:scale-[0.98] ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130 40"
        className="h-full w-auto"
        aria-hidden
        focusable="false"
      >
        {/* Google Play triangle — 4-color */}
        <g transform="translate(4 8) scale(0.95)">
          <path d="M0.2 0.6C-.07 .87-.07 1.27.2 1.55l11.55 11.6L15.1 9.85 3.5 0z" fill="#00d2ff" />
          <path d="M15.1 9.85l3.35-3.35L4.3-.13c-.6-.34-1.18-.05-1.4.32l12.2 9.66z" fill="#00f176" />
          <path d="M18.45 6.5L22.6 8.95c1.27.72 1.27 2.27 0 2.98l-4.15 2.42-3.35-3.85 3.35-4z" fill="#ffce00" />
          <path d="M15.1 9.85L2.9 22.5c.22.37.8.65 1.4.32l14.15-8.5-3.35-4.47z" fill="#ff3a44" />
        </g>
        {/* "Disponibile su" micro-text */}
        <text
          x="32"
          y="15"
          fill="#fff"
          fontSize="7.5"
          fontFamily="-apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', Arial, sans-serif"
          letterSpacing="0.4"
        >
          Disponibile su
        </text>
        {/* "Google Play" wordmark */}
        <text
          x="32"
          y="30"
          fill="#fff"
          fontSize="14.5"
          fontWeight="600"
          fontFamily="-apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', Arial, sans-serif"
          letterSpacing="-0.3"
        >
          Google Play
        </text>
      </svg>
    </a>
  );
}

export { PLAY_STORE_URL };
